module.exports = __webpack_public_path__ + "img/panelselected.a78c4f2e.svg";